/* 
    This Regex accepts both EthioTelecom & Safaricom numbers 
    starting with +2519 | +2517 | 2519 | 2517 | 09 | 07 | 9 | 7
*/
export const phoneRegex = /^(\+?251[79]|0?[79])[0-9]{8}$/
